import moment from 'moment/moment'
import dateTimeMask from './dateTimeMask'

const timestampToUTCDateStr = (timestamp: number, mask = dateTimeMask) => {
    if (!timestamp) {
        return null
    }
    const momentObj = moment(timestamp * 1000)

    return momentObj.isValid() ? momentObj.utc().format(mask) : null
}

export default timestampToUTCDateStr
